export default __webpack_public_path__ + "static/media/complementary--maximum-speed-limit-20--g1.d2e11200.png";